<template>
  <div class="weather-carousel">
    <EBaseCarousel>
      <ul
        ref="content"
        :aria-label="$t('web.widgets.weather.forecast.title')"
        class="weather-carousel__content"
        data-test-id="weather-carousel-content"
      >
        <slot />
      </ul>
      <template #previous-control="{ visible, getCurrentScrollPosition }">
        <EButton
          class="weather-carousel__control weather-carousel__control--prev"
          :class="{ 'weather-carousel__control--visible': !isMobile && visible }"
          icon="chevron-left"
          variant="bare"
          icon-size="s"
          data-test-id="weather-carousel-control-previous"
          @click="onPrevious(getCurrentScrollPosition)"
        />
      </template>
      <template #next-control="{ visible, getCurrentScrollPosition }">
        <EButton
          class="weather-carousel__control weather-carousel__control--next"
          :class="{ 'weather-carousel__control--visible': !isMobile && visible }"
          icon="chevron-right"
          variant="bare"
          icon-size="s"
          data-test-id="weather-carousel-control-next"
          @click="onNext(getCurrentScrollPosition)"
        />
      </template>
    </EBaseCarousel>
  </div>
</template>

<script>
import EBaseCarousel from '~~/common/vue/components/base-carousel';
import EButton from '~~/common/vue/components/button';
import CarouselController, { PageBasedScrolling } from '~~/common/js/client/carousel';

export default {
  name: 'EForecastCarousel',
  components: {
    EBaseCarousel,
    EButton,
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    this.carousel = new CarouselController({
      algorithm: new PageBasedScrolling(),
      container: this.$refs.content,
      items: Array.from(this.$refs.content.getElementsByClassName('forecast-item')),
    });
  },
  updated() {
    this.carousel.items = Array.from(this.$refs.content.getElementsByClassName('forecast-item'));
  },
  methods: {
    async onPrevious(getCurrentScrollPosition) {
      this.carousel.previous(getCurrentScrollPosition());
    },
    async onNext(getCurrentScrollPosition) {
      this.carousel.next(getCurrentScrollPosition());
    },
  },
};
</script>

<style lang="scss" scoped>
.weather-carousel {
  position: relative;
}

.weather-carousel__content {
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.weather-carousel__control {
  --transition-offset: -10%;

  transition: opacity $timing-2s $easing, transform $timing-2s $easing;
  position: absolute;
  border: 0;
  background: none;
  padding: 0;
  z-index: $z-index-l;
  pointer-events: none;
  opacity: 0;
  transform: translate(var(--transition-offset), -50%);
  top: 50%;
}

.weather-carousel__control--visible {
  pointer-events: auto;
  opacity: 1;
  transform: translate(0, -50%);
}

.weather-carousel__control--prev {
  --transition-offset: 10%;

  left: -$space-m;
}

.weather-carousel__control--next {
  right: -$space-m;
}
</style>
